import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import { useState } from 'react'

export default ({
  defaultValues = {},
  onSubmit,
  validationSchema,
  validationType = 'object',
}) => {
  const [error, setError] = useState(null)
  const [isValid, setIsValid] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [validationErrors, setValidationErrors] = useState({})
  const [values, setValues] = useState(defaultValues)

  // Update an individual field
  const handleChange = event => {
    event.persist()

    // Clone the reactive data into a non-reactive object
    let clone = cloneDeep(values)

    // Deeply set any fields
    set(clone, event.target.name, event.target.value)

    // Update the values
    setValues(values => clone)
  }

  const handleSubmit = async event => {
    event.preventDefault()

    // If we have validation schema, let's validate
    if (validationSchema) {
      try {
        // Validation is available as a boolean (simple true/false) or an object(individual field messages)
        const validator =
          validationType === 'boolean'
            ? await validationSchema.isValid(values)
            : await validationSchema.validate(values, {
                abortEarly: false,
              })

        if (validationType === 'boolean') {
          setIsValid(false)
        } else {
          setValidationErrors({})
        }

        try {
          setSubmitting(true)

          await onSubmit()
          setSubmitting(false)
        } catch (caughtError) {
          // If our submission fails, set the form error object
          setError(caughtError.response)
          setSubmitting(false)
        }
      } catch (validationError) {
        // If validation failed, we catch Yup's error object here
        if (validationType === 'boolean') {
          setIsValid(true)
        } else {
          let tmp = {}

          // Iterate through the errors and push them to a tmp object
          validationError.inner.forEach(inner => {
            tmp[inner.path] = inner.message
          })

          // Set the tmp object ot be the validation errors
          setValidationErrors(tmp)
        }

        setSubmitting(false)
      }
    }
  }

  return {
    error,
    handleChange,
    handleSubmit,
    isValid,
    setValues,
    submitting,
    validationErrors,
    values,
  }
}
